import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { logout } from '../services/api'
import { wsService } from '../services/websocket'

const FLEET_KEYS = [
  'fleet_driver_name', 'fleet_account_id', 'fleet_account_name', 'fleet_account_slug',
  'fleet_company_slug', 'fleet_impersonated_account_id', 'fleet_impersonated_account_name',
  'dashboard-sidebar-width',
]

/** Single logout routine shared by the rail, the drawer and the palette. */
export function useLogout() {
  const navigate = useNavigate()
  const clearAuth = useAuthStore(s => s.clearAuth)
  return useCallback(() => {
    // Preserve the company slug so the login form pre-fills next time.
    const savedSlug = localStorage.getItem('fleet_company_slug')
    wsService.disconnect()
    logout() // POST /api/v1/auth/logout + clear jwt/role
    FLEET_KEYS.forEach(k => localStorage.removeItem(k))
    clearAuth()
    if (savedSlug) localStorage.setItem('fleet_company_slug', savedSlug)
    navigate('/login')
  }, [navigate, clearAuth])
}
